import React, { useCallback, useMemo, useState } from "react";
import { Checkbox, Button } from "antd";
import * as R from "ramda";

import * as gtag from "../../../../../lib/gtag";

import { Container, Title, StyledCheckbox } from "./FilterComponents";
import OptionsModal from "./OptionsModal";

function CheckboxFilters({
  grouped,
  loading,
  maxLength,
  options,
  placeholder,
  selectAllLabel,
  setValues,
  sorted,
  title,
  values,
  viewMoreLabels
}) {
  const [visible, setVisible] = useState(false);
  const anyChecked = useMemo(() => R.not(R.isEmpty(values)), [values]);
  const indeterminate = useMemo(() => !R.eqBy(R.length, options, values), [
    options,
    values
  ]);
  const handleChange = useCallback(
    event => setValues(event.target.checked ? R.pluck("value", options) : []),
    [options, setValues]
  );

  const [checkedValues, uncheckedValues] = useMemo(
    () =>
      options && options.length > 0
        ? options.length > maxLength
          ? R.partition(o => R.includes(o.value, values), options)
          : [options, []]
        : [[], []],
    [maxLength, options, values]
  );

  const source =
    checkedValues.length < maxLength
      ? R.concat(
          checkedValues,
          R.take(maxLength - checkedValues.length, uncheckedValues)
        )
      : R.take(maxLength, checkedValues);

  const counter =
    checkedValues.length > 0 && uncheckedValues.length > 0
      ? `(${checkedValues.length})`
      : "";

  const settingValue = ({ target: { checked, value } }) => {
    gtag.event({
      category: "VacancyCandidates",
      action: title
    });
    setValues(
      checked ? [...values, value] : R.filter(o => o !== value, values)
    );
  };

  return (
    <details open={anyChecked}>
      <Title>
        <h4>{`${title} ${counter}`}</h4>
      </Title>
      <Container>
        {selectAllLabel && (
          <StyledCheckbox
            bold
            checked={!indeterminate && anyChecked}
            indeterminate={indeterminate && anyChecked}
            onChange={handleChange}
            disabled={loading}
          >
            {selectAllLabel}
          </StyledCheckbox>
        )}
        <Checkbox.Group
          value={values}
          disabled={loading} // TODO: Set this to "loading" prop, after integration
        >
          {source.map(({ label, value }) => (
            <StyledCheckbox key={value} value={value} onClick={settingValue}>
              {label}
            </StyledCheckbox>
          ))}
          {options.length > maxLength && (
            <Button
              ghost
              size="small"
              style={{
                color: "#747c84",
                fontSize: 12,
                marginLeft: 16,
                border: 0
              }}
              type="link"
              disabled={loading}
              onClick={() => {
                gtag.event({
                  category: "VacancyCandidates",
                  action: `${title}-viewMore`
                });
                setVisible(true);
              }}
            >
              {viewMoreLabels}
            </Button>
          )}
        </Checkbox.Group>
        {visible && (
          <OptionsModal
            visible={visible}
            onClose={() => setVisible(false)}
            options={options}
            title={title}
            values={values}
            setValues={setValues}
            sorted={sorted}
            grouped={grouped}
            placeholder={placeholder}
          />
        )}
      </Container>
    </details>
  );
}

export default CheckboxFilters;
